import {
  ParagraphText,
  StackLayout,
  TextAction,
} from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';
import { useExternalLinks } from 'hooks/use-external-links/use-external-links.hook';
import { usePatientPortalContext } from 'contexts/patient-portal-provider.context';
import { PATIENT_PORTAL_SYSTEM_IDS } from 'types/patient-portal-system.types';

export const SignInFooter = () => {
  const { formatMessage } = useIntl();
  const { systemId } = usePatientPortalContext();
  const externalLinks = useExternalLinks();

  const isMyHealth = systemId === PATIENT_PORTAL_SYSTEM_IDS.MY_HEALTH;

  if (!externalLinks.PRIVACY && (isMyHealth || !externalLinks.TERMS))
    return null;

  return (
    <StackLayout
      horizontalAlignment="center"
      css={{ position: 'relative', marginBlockStart: '$one', width: '100%' }}
    >
      <ParagraphText size="sm">
        {externalLinks.PRIVACY && (
          <TextAction
            href={externalLinks.PRIVACY}
            target="_blank"
            rel="noopener noreferrer"
            size="medium"
            css={{
              textDecoration: 'underline',
            }}
          >
            {formatMessage({ id: 'STR_COLLECTION_NOTICE' })}
          </TextAction>
        )}

        {!isMyHealth && externalLinks.TERMS && (
          <>
            {externalLinks.PRIVACY && ` ${formatMessage({ id: 'STR_AND' })} `}
            <TextAction
              href={externalLinks.TERMS}
              target="_blank"
              rel="noopener noreferrer"
              size="medium"
              css={{ textDecoration: 'underline' }}
            >
              {formatMessage({ id: 'STR_TERMS_OF_SERVICE' })}
            </TextAction>
          </>
        )}
      </ParagraphText>
    </StackLayout>
  );
};
